// frontend/src/pages/PresupuestosPage.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import PresupuestoModal from '../components/PresupuestoModal';
import CrearPresupuestoModal from '../components/CrearPresupuestoModal';
import OrdenesCompraResumen from '../components/OrdenesCompraResumen';

import Loading from '../components/Loading';
const PresupuestosPage = () => {
  const [periodo, setPeriodo] = useState('2025');
  const [presupuestos, setPresupuestos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedPresupuesto, setSelectedPresupuesto] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    cargarPresupuestos();
  }, [periodo]);

  const cargarPresupuestos = async () => {
    try {
      setLoading(true);
      const response = await presupuestosService.getPresupuestosByPeriodo(periodo);
      console.log('🔍 getPresupuestosByPeriodo response:', response.data);

      let presupuestosData = [];

      // Manejar respuesta paginada de Django REST Framework
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        console.log('✅ Presupuestos (paginado):', response.data.results.length);
        presupuestosData = response.data.results;
      }
      // Manejar respuesta directa de array
      else if (Array.isArray(response.data)) {
        console.log('✅ Presupuestos (array directo):', response.data.length);
        presupuestosData = response.data;
      }
      // Error: estructura no reconocida
      else {
        console.warn('⚠️ Presupuestos estructura no reconocida:', response.data);
        presupuestosData = [];
      }

      setPresupuestos(presupuestosData);
    } catch (error) {
      console.error('Error al cargar presupuestos:', error);
      toast.error('Error al cargar presupuestos');
      setPresupuestos([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePresupuesto = async (data) => {
    try {
      await presupuestosService.createPresupuesto(data);
      toast.success('Presupuesto creado exitosamente');
      setShowCreateModal(false);
      cargarPresupuestos();
    } catch (error) {
      console.error('Error al crear presupuesto:', error);
      toast.error('Error al crear presupuesto');
    }
  };

  const handleDeletePresupuesto = async (id) => {
    if (window.confirm('¿Estás seguro de que quieres eliminar este presupuesto?')) {
      try {
        await presupuestosService.deletePresupuesto(id);
        toast.success('Presupuesto eliminado exitosamente');
        cargarPresupuestos();
      } catch (error) {
        console.error('Error al eliminar presupuesto:', error);
        toast.error('Error al eliminar presupuesto');
      }
    }
  };

  const filteredPresupuestos = presupuestos.filter(p =>
    p.nombre_presupuesto.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const presupuestosActivos = filteredPresupuestos.filter(p => p.status !== 'archived');
  const presupuestosArchivados = filteredPresupuestos.filter(p => p.status === 'archived');

  return (
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '2rem'
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        borderRadius: '16px',
        padding: '2rem',
        marginBottom: '2rem',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
        transition: 'box-shadow 0.3s',
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <h1 style={{
          margin: 0,
          fontSize: '2rem',
          color: '#102826',
          fontWeight: 700
        }}>💰 Presupuestos</h1>

        <button
          onClick={() => setShowCreateModal(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '0.95rem',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            background: 'linear-gradient(135deg, #10b981 0%, #0ea574 100%)',
            color: 'white',
            flexShrink: 0
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 12px -2px rgba(0, 0, 0, 0.15)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
          }}
        >
          ➕ Nuevo Presupuesto
        </button>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <select
            value={periodo}
            onChange={(e) => setPeriodo(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '0.95rem',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              fontWeight: 500
            }}
          >
            <option value="2025">2025</option>
            <option value="2026">2026</option>
          </select>
        </div>

        <div style={{ flex: 1, minWidth: '200px' }}>
          <input
            type="text"
            placeholder="🔍 Buscar presupuesto..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '0.95rem',
              transition: 'all 0.2s ease'
            }}
          />
        </div>
      </div>

      {/* Órdenes de Compra Resumen */}
      <OrdenesCompraResumen periodo={periodo} />

      {/* Contenido */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem'
      }}>
        {loading ? (
          <Loading fullScreen={false} mensaje="Cargando presupuestos" />
        ) : presupuestosActivos.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            background: 'white',
            borderRadius: '16px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
          }}>
            <p style={{
              margin: '0 0 1.5rem 0',
              color: '#6b7280',
              fontSize: '1.1rem'
            }}>
              📭 No hay presupuestos para el período {periodo}
            </p>
            <button
              onClick={() => setShowCreateModal(true)}
              style={{
                padding: '0.75rem 1.5rem',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '0.95rem',
                background: 'linear-gradient(135deg, #10b981 0%, #0ea574 100%)',
                color: 'white',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 12px -2px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
              }}
            >
              Crear Presupuesto
            </button>
          </div>
        ) : (
          <>
            {/* Presupuestos Activos */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
              gap: '1.5rem'
            }}>
              {presupuestosActivos.map(presupuesto => {
                const statusColors = {
                  borrador: { border: '#f59e0b', bg: '#fef3c7', text: '#92400e' },
                  activo: { border: '#10b981', bg: '#d1fae5', text: '#065f46' },
                  cerrado: { border: '#6366f1', bg: '#e0e7ff', text: '#3730a3' }
                };
                const statusColor = statusColors[presupuesto.status] || statusColors.activo;

                return (
                  <div
                    key={presupuesto.id}
                    style={{
                      background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
                      border: '1px solid rgba(0, 0, 0, 0.05)',
                      borderLeft: `4px solid ${statusColor.border}`,
                      borderRadius: '16px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      cursor: 'pointer'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)';
                    }}
                  >
                    {/* Card Header */}
                    <div style={{
                      padding: '1.5rem 1.5rem 1rem 1.5rem',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'start',
                      gap: '1rem',
                      borderBottom: '1px solid #f3f4f6'
                    }}>
                      <h3 style={{
                        margin: 0,
                        fontSize: '1.1rem',
                        color: '#102826',
                        fontWeight: 700,
                        flex: 1
                      }}>
                        {presupuesto.nombre_presupuesto}
                      </h3>
                      <span style={{
                        padding: '0.25rem 0.75rem',
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        whiteSpace: 'nowrap',
                        background: statusColor.bg,
                        color: statusColor.text
                      }}>
                        {presupuesto.status}
                      </span>
                    </div>

                    {/* Card Body */}
                    <div style={{ padding: '1.5rem' }}>
                      {/* Info Rows */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.75rem',
                        fontSize: '0.95rem'
                      }}>
                        <span style={{ color: '#6b7280', fontWeight: 500 }}>Equipo:</span>
                        <span style={{ color: '#102826', fontWeight: 600 }}>{presupuesto.equipo_nombre}</span>
                      </div>

                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.75rem',
                        fontSize: '0.95rem'
                      }}>
                        <span style={{ color: '#6b7280', fontWeight: 500 }}>Período:</span>
                        <span style={{ color: '#102826', fontWeight: 600 }}>{presupuesto.periodo}</span>
                      </div>

                      {/* Separator */}
                      <div style={{
                        height: '1px',
                        background: '#f3f4f6',
                        margin: '1rem 0'
                      }}></div>

                      {/* Budget Info Grid */}
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        gap: '1rem',
                        marginBottom: '1rem'
                      }}>
                        <div style={{
                          textAlign: 'center',
                          padding: '0.75rem',
                          background: '#f9fafb',
                          borderRadius: '8px'
                        }}>
                          <span style={{
                            display: 'block',
                            color: '#6b7280',
                            fontSize: '0.85rem',
                            marginBottom: '0.25rem',
                            fontWeight: 500
                          }}>Consumido</span>
                          <span style={{
                            display: 'block',
                            color: '#102826',
                            fontSize: '0.95rem',
                            fontWeight: 600
                          }}>
                            ${presupuesto.presupuesto_consumido.toLocaleString('es-CL')}
                          </span>
                        </div>

                        <div style={{
                          textAlign: 'center',
                          padding: '0.75rem',
                          background: '#f9fafb',
                          borderRadius: '8px'
                        }}>
                          <span style={{
                            display: 'block',
                            color: '#6b7280',
                            fontSize: '0.85rem',
                            marginBottom: '0.25rem',
                            fontWeight: 500
                          }}>Total</span>
                          <span style={{
                            display: 'block',
                            color: '#102826',
                            fontSize: '0.95rem',
                            fontWeight: 600
                          }}>
                            ${presupuesto.total_presupuesto.toLocaleString('es-CL')}
                          </span>
                        </div>

                        <div style={{
                          textAlign: 'center',
                          padding: '0.75rem',
                          background: '#f9fafb',
                          borderRadius: '8px'
                        }}>
                          <span style={{
                            display: 'block',
                            color: '#6b7280',
                            fontSize: '0.85rem',
                            marginBottom: '0.25rem',
                            fontWeight: 500
                          }}>Diferencia</span>
                          <span style={{
                            display: 'block',
                            color: presupuesto.diferencia_presupuestaria >= 0 ? '#10b981' : '#ef4444',
                            fontSize: '0.95rem',
                            fontWeight: 600
                          }}>
                            ${presupuesto.diferencia_presupuestaria.toLocaleString('es-CL')}
                          </span>
                        </div>
                      </div>

                      {/* Progress Bar */}
                      <div style={{
                        position: 'relative',
                        height: '24px',
                        background: '#e5e7eb',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        marginBottom: '1rem'
                      }}>
                        <div style={{
                          height: '100%',
                          width: `${Math.min(presupuesto.porcentaje_utilizado, 100)}%`,
                          background: presupuesto.porcentaje_utilizado > 100
                            ? 'linear-gradient(90deg, #ef4444 0%, #dc2626 100%)'
                            : 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
                          transition: 'width 0.3s ease'
                        }}></div>
                        <span style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          color: 'white',
                          textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                        }}>
                          {presupuesto.porcentaje_utilizado.toFixed(1)}%
                        </span>
                      </div>
                    </div>

                    {/* Card Actions */}
                    <div style={{
                      display: 'flex',
                      gap: '0.5rem',
                      padding: '1rem 1.5rem 1.5rem 1.5rem',
                      borderTop: '1px solid #f3f4f6'
                    }}>
                      <button
                        onClick={() => setSelectedPresupuesto(presupuesto)}
                        title="Abrir presupuesto"
                        style={{
                          flex: 1,
                          padding: '0.625rem 1rem',
                          fontSize: '0.875rem',
                          background: 'linear-gradient(135deg, #10b981 0%, #0ea574 100%)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontWeight: 600,
                          transition: 'all 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '0.375rem'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.background = '#059669';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.background = 'linear-gradient(135deg, #10b981 0%, #0ea574 100%)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        👁️ Abrir
                      </button>
                      <button
                        onClick={() => handleDeletePresupuesto(presupuesto.id)}
                        title="Eliminar presupuesto"
                        style={{
                          padding: '0.625rem',
                          width: '2.75rem',
                          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontWeight: 600,
                          transition: 'all 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.background = '#dc2626';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.background = 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Presupuestos Archivados */}
            {presupuestosArchivados.length > 0 && (
              <div style={{
                marginTop: '2rem',
                paddingTop: '2rem',
                borderTop: '2px solid #f3f4f6'
              }}>
                <h3 style={{
                  color: '#6b7280',
                  margin: '0 0 1.5rem 0',
                  fontSize: '1.2rem',
                  fontWeight: 600
                }}>
                  📦 Presupuestos Archivados ({presupuestosArchivados.length})
                </h3>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                  gap: '1.5rem'
                }}>
                  {presupuestosArchivados.map(presupuesto => (
                    <div
                      key={presupuesto.id}
                      style={{
                        background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
                        border: '1px solid rgba(0, 0, 0, 0.05)',
                        borderLeft: '4px solid #9ca3af',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                        opacity: 0.65,
                        transition: 'all 0.3s'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.opacity = '0.85';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.opacity = '0.65';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      <div style={{
                        padding: '1.5rem 1.5rem 1rem 1.5rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'start',
                        gap: '1rem',
                        borderBottom: '1px solid #f3f4f6'
                      }}>
                        <h3 style={{
                          margin: 0,
                          fontSize: '1.1rem',
                          color: '#102826',
                          fontWeight: 700,
                          flex: 1
                        }}>
                          {presupuesto.nombre_presupuesto}
                        </h3>
                        <span style={{
                          padding: '0.25rem 0.75rem',
                          borderRadius: '20px',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          background: '#f3f4f6',
                          color: '#6b7280'
                        }}>
                          archivado
                        </span>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '0.5rem',
                        padding: '1rem 1.5rem 1.5rem 1.5rem',
                        borderTop: '1px solid #f3f4f6'
                      }}>
                        <button
                          onClick={() => handleDeletePresupuesto(presupuesto.id)}
                          style={{
                            flex: 1,
                            padding: '0.625rem',
                            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: 600,
                            transition: 'all 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.background = '#dc2626';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.background = 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)';
                          }}
                        >
                          🗑️ Eliminar
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Modales */}
      {showCreateModal && (
        <CrearPresupuestoModal
          onClose={() => setShowCreateModal(false)}
          onCreate={handleCreatePresupuesto}
          periodo={periodo}
        />
      )}

      {selectedPresupuesto && (
        <PresupuestoModal
          presupuesto={selectedPresupuesto}
          onClose={() => setSelectedPresupuesto(null)}
          onUpdate={cargarPresupuestos}
        />
      )}
    </div>
  );
};

export default PresupuestosPage;
